<template>
  <div class="layout-padding">
    <!-- 查詢 -->
    <q-card>
      <!-- <div class="row col-12"> -->
      <q-toolbar class="text-blue-8">
        <q-avatar>
          <q-icon name="fas fa-key"></q-icon>
        </q-avatar>
        <q-toolbar-title>
          變更密碼
        </q-toolbar-title>
      </q-toolbar>
      <div class="row col-12">
        <div class="col-12">
          <div class="row col-12; justify-center">
            <q-input
            ref="inputOld"
            class="col-6 col-md-4"
            dense outlined v-model="model.oldPassword"
            :type="isPwd ? 'password' : 'text'"
            placeholder="請輸入原密碼"
            :rules="[
            val => !!val || '請輸入原密碼',
            ]">
              <template v-slot:append>
                <q-icon
                  :name="isPwd ? 'visibility_off' : 'visibility'"
                  class="cursor-pointer"
                  @click="isPwd = !isPwd"
                />
              </template>
            </q-input>
          </div>
          <div class="row col-12; justify-center">
            <q-input
            ref="inputNew"
            class="col-6 col-md-4"
            :type="isNewPwd ? 'password' : 'text'"
            dense outlined
            v-model="model.newPassword"
            placeholder="請輸入新密碼"
            :rules="[
              val => !!val || '請輸入新密碼',
              val => val !== this.model.userAccount || '需與帳號(工號)不同',
              val => val !== this.model.oldPassword || '新密碼需與舊密碼不同'
            ]">
              <template v-slot:append>
                <q-icon
                  :name="isNewPwd ? 'visibility_off' : 'visibility'"
                  class="cursor-pointer"
                  @click="isNewPwd = !isNewPwd"
                />
              </template>
            </q-input>
          </div>
          <div class="row col-12; justify-center">
            <q-input ref="inputConfirm" class="col-6 col-md-4"
            dense outlined v-model="model.confirmPassword"
            :type="isConfirmPwd ? 'password' : 'text'"
            placeholder="請確認密碼"
            :rules="[
            val => !!val || '請輸入確認密碼',
            val => val === this.model.newPassword || '確認密碼錯誤，請重新輸入！'
            ]">
              <template v-slot:append>
                <q-icon
                  :name="isConfirmPwd ? 'visibility_off' : 'visibility'"
                  class="cursor-pointer"
                  @click="isConfirmPwd = !isConfirmPwd"
                />
              </template>
            </q-input>
          </div>
          <div class="row col-12; justify-start">
            <div class="col-3 col-md-4"></div>
            <q-input
              class="col-3 text-left"
              outlined
              dense
              :label-width="5"
              placeholder="請輸入圖片中之文字"
              v-model="model.captcha"
              :error="captchaErrorMessage !== ''"
              :error-message="captchaErrorMessage"
              :rules="[
              ]"
              mask="####">
            </q-input>
            <!-- <div class="col-2"> -->
              <img class="col-1" style="width:90px;height:42px;padding: 0px;margin-bottom: 0.5em;" :src="captchaImage">
              <a class="text-primary q-mt-sm q-ml-sm" @click="getCaptcha('login')"><i class="fas fa-sync-alt"></i></a>
            <!-- </div> -->

          </div>
          <div class="row col-12 items-center justify-center text-negative q-mb-sm"><i class="fas fa-exclamation-circle q-mr-xs"></i> 英數混合至少10碼。</div>
        </div>
      </div>
      <div class="row col-12 justify-center items-center">
        <q-btn v-show="$route.params.routeName !== 'Login'" class="searchBtn" push style="margin-right: 1em;" color="primary" label="取消" @click="reset"/>
        <q-btn class="searchBtn" push color="primary" label="更新" @click="submitChangePassword()"/>
      </div>
    </q-card>
  </div>
</template>

<script>
import { commonMixin } from '@/common/js/mixins'

export default {
  name: 'changepassword',
  mixins: [commonMixin],
  mounted () {
    console.log('changePassword mounted')
    this.model.userAccount = this.$store.getters.getUserAccount
    console.log('userAccount : ' + this.model.userAccount)
    this.getCaptcha()
    // setTimeout(() => {
    //   if (this.$route.params.routeName === 'Login') {
    //     this.message('您的密碼已到期，請更新密碼！', '確認', '')
    //   }
    // }, 500)
  },
  data () {
    return {
      isPwd: true,
      isNewPwd: true,
      isConfirmPwd: true,
      model: {
        userAccount: '',
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
        captcha: '',
        encodeCaptcha: ''
      },
      captchaImage: '',
      captchaErrorMessage: ''
    }
  },
  methods: {
    reset () {
      // this.$refs.inputOld.resetValidation()
      // this.$refs.inputNew.resetValidation()
      // this.$refs.inputConfirm.resetValidation()
      // this.$router.push('/login')
      history.go(-1)
    },
    getCaptcha () {
      this.get('login/getCaptcha', {}, r => {
        let c = r.split('|')
        this.model.encodeCaptcha = c[0]
        this.captchaImage = 'data:image/png;base64,' + c[1]
      })
    },
    validateCaptcha (captcha, encodeCaptcha) {
      return new Promise((resolve, reject) => {
        if (captcha === '') {
          this.captchaErrorMessage = '請輸入驗證碼'
          reject(this.captchaErrorMessage)
        } else {
          this.get('login/validateCaptcha', { captcha: captcha, encodeCaptcha: encodeCaptcha }, r => {
            this.captchaErrorMessage = ''
            resolve(this.captchaErrorMessage)
          })
        }
      })
    },
    submitChangePassword () {
      // 檢查全部資料不為空
      if (this.model.oldPassword !== '' && this.model.newPassword !== '' && this.model.confirmPassword !== '') {
        // 檢查 新密碼與 舊密碼不同
        if (this.model.oldPassword !== this.model.newPassword) {
          // 檢查 確認密碼與新密碼相同
          if (this.model.newPassword === this.model.confirmPassword) {
            // 驗證密碼邏輯
            if (this.validatePassword()) {
              // 檢查驗證碼
              this.validateCaptcha(this.model.captcha, this.model.encodeCaptcha).then(response => {
                this.post('/login/changePassword',
                  {
                    username: this.model.userAccount,
                    oldPassword: this.model.oldPassword,
                    newPassword: this.model.newPassword
                  }, r => {
                    this.successMessage('已變更密碼')
                    this.$store.commit('logout')
                    this.$router.push('/')
                  })
              })
            }
          }
        }
      }
    },
    validatePassword () {
      let regex = /(?=.*[a-zA-Z])(?=.*[0-9])/
      let username = this.model.userAccount
      let newPassword = this.model.newPassword
      let oldPassword = this.model.oldPassword
      let flag = false
      if (!oldPassword) {
        this.showError('請輸入原密碼')
      }
      if (!newPassword) {
        this.showError('請輸入新密碼')
      } else if (newPassword.length < 10) {
        this.showError('新密碼最少10碼')
      } else if (!regex.test(newPassword)) {
        this.showError('新密碼需有英文、數字至少10碼')
      } else if (newPassword === username) {
        this.showError('新密碼不可與帳號(工號)相同')
      } else if (newPassword === oldPassword) {
        this.showError('新密碼需與原密碼不同')
      } else {
        flag = true
      }
      return flag
    }
  }
}
</script>

<style>
.searchBtn {
  width:100px;
}
</style>
